/* eslint-disable consistent-return */
import { useEffect } from 'react';
import { useDownloadContext } from '../contexts/DownloadContext';
import downloadManager from '../utils/managers/downloadManager';

/**
 * 파일 다운로드 관련 기능을 제공하는 커스텀 훅
 *
 * @param {Object} options - 훅 옵션
 * @param {string} options.userId - 사용자 ID
 * @param {string} options.userName - 사용자 이름
 * @returns {Object} 다운로드 관련 메서드와 상태
 */
export default function useDownload() {
  // 다운로드 컨텍스트 가져오기
  const downloadContext = useDownloadContext();

  // 다운로드 중 페이지 이탈 경고
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (downloadManager.hasActiveDownloads()) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return {
    ...downloadContext,
    showPanel: () => downloadContext.toggleVisibility(true),
    hidePanel: () => downloadContext.toggleVisibility(false),
  };
}
